import * as React from 'react';
import SvgIcon from './SvgIcon';
import {IconProps} from './types';

export default class IconCheckCircle extends React.Component<IconProps, {}> {
  public render() {
    return (
      <SvgIcon {...this.props} viewBox="0 0 20 20">
        <g transform="translate(-16 -139)">
          <circle fill="currentColor" cx="10" cy="10" r="10" transform="translate(16 139)" />
          <path
            fill="none"
            stroke="#fff"
            strokeWidth={2}
            d="M1126.667,209.649l3.474,2.684,4.737-6"
            transform="translate(-1105.167 -60.833)"
          />
        </g>
      </SvgIcon>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SvgIcon/IconCheckCircle.tsx